"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMoneyLabel = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const roundMoney_1 = require("../../../utils/roundMoney");
require("./index.scss");
const className = 'payment-money-label';
const PaymentMoneyLabel = (props) => {
    const { label, price, error, hidden } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const priceClassNames = (0, classFunctions_1.getClassNames)(`${className}__price`, [
        error ? 'error' : undefined,
    ]);
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__title` }, label),
        react_1.default.createElement("div", { className: priceClassNames }, `${(0, roundMoney_1.localizeMoney)(price, locale, 'Payment/MoneyLabel')} CHF`)));
};
exports.PaymentMoneyLabel = PaymentMoneyLabel;
//# sourceMappingURL=index.js.map